module.exports = __webpack_public_path__ + "static/media/VR.623d1e1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ministries/VR.svg
// module id = 252
// module chunks = 0